import { Component, OnInit } from "@angular/core";
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { ContactUsService } from "src/app/Services/contactus.service";
import { FormProtectionService } from "src/app/Services/form-protection.service";

@Component({
  selector: "app-contact-us",
  templateUrl: "./contact-us.component.html",
  styleUrls: ["./contact-us.component.scss"],
})
export class ContactUsComponent implements OnInit {
  public contactForm: UntypedFormGroup;
  isSubmitting = false;
  showRecaptchaNotice = false;
  private readonly formLoadedAt = Date.now();

  constructor(
    private contactusService: ContactUsService,
    private toastr: ToastrService,
    private formProtection: FormProtectionService
  ) {}

  ngOnInit(): void {
    this.contactForm = new UntypedFormGroup({
      name: new UntypedFormControl("", [
        Validators.required,
        Validators.maxLength(60),
      ]),
      message: new UntypedFormControl("", [
        Validators.required,
        Validators.maxLength(1000),
      ]),
      email: new UntypedFormControl("", [
        Validators.required,
        Validators.email,
      ]),
      website: new UntypedFormControl(""),
    });

    this.formProtection.isRecaptchaEnabled().then((enabled) => {
      this.showRecaptchaNotice = enabled;
    });
  }

  async submit() {
    if (!this.contactForm.valid || this.isSubmitting) {
      Object.keys(this.contactForm.controls).forEach((key) => {
        this.contactForm.get(key)?.markAsTouched();
      });
      return;
    }

    this.isSubmitting = true;

    try {
      const formValues = this.contactForm.value;
      const recaptchaToken = await this.formProtection.getRecaptchaToken(
        "contact_us"
      );

      const contactus: Record<string, unknown> = {
        Message: formValues.message,
        Name: formValues.name,
        Email: formValues.email,
        Website: formValues.website || "",
        FormLoadedAt: this.formLoadedAt,
      };

      if (recaptchaToken) {
        contactus.RecaptchaToken = recaptchaToken;
      }

      this.contactusService.postContactUs(contactus).subscribe({
        next: () => {
          this.isSubmitting = false;
          this.toastr.success(
            "Your contact us request is submitted. Thank you"
          );
          this.contactForm.reset();
        },
        error: () => {
          this.isSubmitting = false;
          this.toastr.error("Failed to submit contact form. Please try again.");
        },
      });
    } catch {
      this.isSubmitting = false;
      this.toastr.error("Failed to submit contact form. Please try again.");
    }
  }

  public hasError = (controlName: string, errorName: string) => {
    return this.contactForm.controls[controlName].hasError(errorName);
  };
}
